import { useState } from "react";
import { resolveImagePath } from "@/utils/imageResolver";

export function Header() {
  const [isStudioDropdownOpen, setIsStudioDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const studioSubmenuItems = [
    { name: "Music Lessons", href: "/music-lessons" },
    { name: "Brass", href: "/brass" },
    { name: "Guitar", href: "/guitar" },
    { name: "Harp", href: "/harp-lessons" },
    { name: "Percussion", href: "/percussion" },
    { name: "Piano", href: "/piano" },
    { name: "Strings", href: "/cello-bass-violin" },
    { name: "Voice", href: "/voice" },
    { name: "Woodwinds", href: "/woodwinds" },
  ];

  return (
    <header className="bg-teal text-white">
      <nav className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-4">
          {/* Logo - Mobile only */}
          <div className="flex-shrink-0 md:hidden">
            <a href="/" className="flex items-center">
              <img
                src={resolveImagePath("/images/logo.png")}
                alt="The Conservatory of Musical Arts"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a
                href="/"
                className="text-white hover:text-gray-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                HOME
              </a>
              
              {/* Studios at CMA Dropdown */}
              <div className="relative">
                <button
                  className="text-white hover:text-gray-200 px-3 py-2 text-sm font-medium transition-colors duration-200 flex items-center"
                  onMouseEnter={() => setIsStudioDropdownOpen(true)}
                  onMouseLeave={() => setIsStudioDropdownOpen(false)}
                >
                  STUDIOS AT CMA
                  <svg
                    className="ml-1 h-4 w-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                
                {isStudioDropdownOpen && (
                  <div
                    className="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md z-50"
                    onMouseEnter={() => setIsStudioDropdownOpen(true)}
                    onMouseLeave={() => setIsStudioDropdownOpen(false)}
                  >
                    <div className="py-1">
                      {studioSubmenuItems.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-200"
                        >
                          {item.name}
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <a
                href="/woodwinds-boutique"
                className="text-white hover:text-gray-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                WOODWIND BOUTIQUE
              </a>
              
              <a
                href="/music-together"
                className="text-white hover:text-gray-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                MUSIC TOGETHER
              </a>
              
              <a
                href="/contact"
                className="text-white hover:text-gray-200 px-3 py-2 text-sm font-medium transition-colors duration-200"
              >
                CONTACT
              </a>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-gray-200 inline-flex items-center justify-center p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            >
              <span className="sr-only">Open main menu</span>
              {!isMobileMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-teal">
              <a
                href="/"
                className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium"
              >
                HOME
              </a>
              
              {/* Mobile Studios Menu */}
              <div>
                <button
                  onClick={() => setIsStudioDropdownOpen(!isStudioDropdownOpen)}
                  className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium w-full text-left flex items-center justify-between"
                >
                  STUDIOS AT CMA
                  <svg
                    className={`h-4 w-4 transform transition-transform ${
                      isStudioDropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                
                {isStudioDropdownOpen && (
                  <div className="pl-6 space-y-1">
                    {studioSubmenuItems.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="text-white hover:text-gray-200 block px-3 py-2 text-sm font-medium"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
              
              <a
                href="/woodwinds-boutique"
                className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium"
              >
                WOODWIND BOUTIQUE
              </a>
              
              <a
                href="/music-together"
                className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium"
              >
                MUSIC TOGETHER
              </a>
              
              <a
                href="/contact"
                className="text-white hover:text-gray-200 block px-3 py-2 text-base font-medium"
              >
                CONTACT
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}